import styles from '../../../pages/foryou/_styles/InfoBlock.module.scss';
import { ComponentProps } from "react";

interface IProps extends ComponentProps<"svg"> {
  isMobile?: boolean;
  liked?: boolean;
}

export const MainLike = ({ isMobile, liked, ...props }: IProps) =>
  !isMobile ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={22}
      fill={liked ? '#FAFAFA' : 'rgba(0, 0, 0, 0)'}
      viewBox="0 0 26 22"
      className={styles.mainLikeIcon}
      {...props}
    >
      <path
        stroke="#FAFAFA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7.6 1C3.955 1 1 3.86955 1 7.40914C1 13.8183 8.8 19.6448 13 21C17.2 19.6448 25 13.8183 25 7.40914C25 3.86955 22.045 1 18.4 1C16.168 1 14.194 2.07615 13 3.7233C12.3914 2.88149 11.5829 2.19448 10.6429 1.72044C9.70294 1.24639 8.65918 0.999274 7.6 1Z"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={19}
      viewBox="0 0 22 19"
      fill={liked ? '#FAFAFA' : 'none'}
      {...props}
    >
      <path
        stroke="#FAFAFA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6.5 1C3.4625 1 1 3.43911 1 6.44777C1 11.8955 7.5 16.848 11 18C14.5 16.848 21 11.8955 21 6.44777C21 3.43911 18.5375 1 15.5 1C13.64 1 11.995 1.91473 11 3.31481C10.4928 2.59927 9.81908 2.01531 9.03577 1.61237C8.25245 1.20944 7.38265 0.999383 6.5 1Z"
      />
    </svg>
  );
